import React, { useEffect, useState } from "react";
import "./Leaderboard.css";

const API_URL = "https://mon-cultists.xyz/api/leaderboard"; 

const formatWallet = (wallet) => {
  return wallet.slice(0, 6) + "..." + wallet.slice(-3).toUpperCase();
};

const Leaderboard = ({ userWallet }) => {
  const [leaders, setLeaders] = useState([]);
  const [userRank, setUserRank] = useState(null);
  const [userCheckins, setUserCheckins] = useState(null);

  useEffect(() => {
    const fetchLeaderboard = async () => {
      try {
        const response = await fetch(API_URL);
        const data = await response.json();
        
        const sortedData = data.sort((a, b) => b.total_checkins - a.total_checkins);
        setLeaders(sortedData);

        const userEntry = sortedData.find((entry) => entry.wallet === userWallet);
        if (userEntry) {
          const rank = sortedData.findIndex((entry) => entry.wallet === userWallet) + 1;
          if (rank > 10) {
            setUserRank(rank);
            setUserCheckins(userEntry.total_checkins);
          }
        }
      } catch (error) {
        console.error("Ошибка загрузки лидерборда:", error);
      }
    };

    fetchLeaderboard();
  }, [userWallet]);

  return (
    <>
      <div className="leaderboard-container">
        <h2 className="leaderboard-title">Leaderboard</h2>
        <table className="leaderboard-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Wallet</th>
              <th>Affirmations sent</th>
            </tr>
          </thead>
          <tbody>
            {leaders.slice(0, 25).map((entry, index) => (
              <tr key={entry.wallet}>
                <td>{index + 1}</td>
                <td>{formatWallet(entry.wallet)}</td>
                <td>{entry.total_checkins}</td>
              </tr>
            ))}
          </tbody>
        </table>

        {userRank && (
          <div className="user-rank">
            <p>Your Rank: {userRank}</p>
            <p>{formatWallet(userWallet)} - {userCheckins} Check-ins</p>
          </div>
        )}
      </div>
    </>
  );
};

export default Leaderboard;
